import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import { useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import TreeVigourMonitoringForm from './TreeVigourMonitoringForm';

const CreateTreeVigourMonitoringModal = ({ monitoringBlock }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;

  const [open, setOpen] = useState(false);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return (
    <>
      <Button
        onClick={() => {
          show();
        }}
      >
        <FontAwesomeIcon icon={faPlus} /> Add Tree Vigour Monitoring
      </Button>
      <Modal backdrop='static' size='md' show={open} onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>
            Create Tree Vigour Monitoring for <b>{monitoringBlock.block_id}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              block_id: monitoringBlock.id,
              date: '',
              terminated_percent: '',
              active_percent: '',
              none_percent: '',
              shoots_infected_percent: '',
              old_damage_count: '',
              new_damage_count: '',
              broken_damage_count: '',
              leaves_per_shoot: '',
              pgr_application_date: '',
              pgr_application_product: ''
            }}
            validate={(values) => {
              const errors = {};
              if (!values.date) errors.date = 'Required';
              if (!values.terminated_percent && values.terminated_percent !== 0)
                errors.terminated_percent = 'Required';
              else if (values.terminated_percent < 0)
                errors.terminated_percent = 'Must be 0 or greater';
              if (!values.active_percent && values.active_percent !== 0)
                errors.active_percent = 'Required';
              else if (values.active_percent < 0)
                errors.active_percent = 'Must be 0 or greater';
              if (!values.none_percent && values.none_percent !== 0)
                errors.none_percent = 'Required';
              else if (values.none_percent < 0)
                errors.none_percent = 'Must be 0 or greater';
              if (
                !values.shoots_infected_percent &&
                values.shoots_infected_percent !== 0
              )
                errors.shoots_infected_percent = 'Required';
              else if (values.shoots_infected_percent < 0)
                errors.shoots_infected_percent = 'Must be 0 or greater';
              if (!values.old_damage_count && values.old_damage_count !== 0)
                errors.old_damage_count = 'Required';
              else if (values.old_damage_count < 0)
                errors.old_damage_count = 'Must be 0 or greater';
              if (!values.new_damage_count && values.new_damage_count !== 0)
                errors.new_damage_count = 'Required';
              else if (values.new_damage_count < 0)
                errors.new_damage_count = 'Must be 0 or greater';
              if (
                !values.broken_damage_count &&
                values.broken_damage_count !== 0
              )
                errors.broken_damage_count = 'Required';
              else if (values.broken_damage_count < 0)
                errors.broken_damage_count = 'Must be 0 or greater';
              if (!values.leaves_per_shoot && values.leaves_per_shoot !== 0)
                errors.leaves_per_shoot = 'Required';
              else if (values.leaves_per_shoot < 0)
                errors.leaves_per_shoot = 'Must be 0 or greater';
              return errors;
            }}
            onSubmit={async (values, actions) => {
              try {
                await alcmStore.createTreeVigourMonitoring({
                  block_id: values.block_id,
                  date: values.date,
                  terminated_percent: values.terminated_percent,
                  active_percent: values.active_percent,
                  none_percent: values.none_percent,
                  shoots_infected_percent: values.shoots_infected_percent,
                  old_damage_count: values.old_damage_count,
                  new_damage_count: values.new_damage_count,
                  broken_damage_count: values.broken_damage_count,
                  leaves_per_shoot: values.leaves_per_shoot,
                  pgr_application_date: values.pgr_application_date || null,
                  pgr_application_product:
                    values.pgr_application_product || null
                });
                successToast('Tree Vigour Monitoring created successfully.');
                hide();
              } catch (err) {
                errorToast('Failed to create Tree Vigour Monitoring.');
              } finally {
                actions.setSubmitting(false);
              }
            }}
          >
            {() => {
              return <TreeVigourMonitoringForm onCancel={hide} />;
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default observer(CreateTreeVigourMonitoringModal);

